const interval = setInterval(() => {
  const recharge = document.querySelector("recharge-subscription-widget");
  if (!recharge || !recharge.shadowRoot) return;

  const root1 = recharge.shadowRoot;
  
  const subcriptionRootInput = root1.querySelector(
    '.rc-purchase-option__subscription input[type="radio"]'
  );

  const oneTimeRoot = root1.querySelector(".rc-selection__onetime");
  const oneTimeInput = root1.querySelector(
    '.rc-selection__onetime input[type="radio"]'
  );
  const widgetRoot = root1.querySelector(".rc-widget__root");

  if (!oneTimeRoot || !oneTimeInput || !widgetRoot) return;

  clearInterval(interval);

  // Inject CSS
  const style = document.createElement("style");
  style.textContent = `
    .rc-purchase-option[rc-selected] .rc-purchase-option__label {
      background: #abdfff;
      border-radius: 6px;
    }
      .rc-purchase-option[rc-selected].custom-active {
        background: none;
        border-color:rgba(0, 159, 255, 0.5);
      .rc-purchase-option__label {
        background: none;
        .rc-purchase-option__selector {
          position:relative;
          &:before {
            content: "";
            position:absolute;
            width:13px;
            height:13px;
            background-color: #fff;
            left:3px;
            top:7px;
            z-index:2;
            border-radius:50%;
          }
          @media (max-width: 767px) {
            &:before {
              width: 10px;
              height: 10px;
              top: 8px;
            }
          }
        }
      }
    }

    .rc-purchase-option[rc-selected] .rc-price.strike-through {
      color:#000;
    }
    @media (max-width:767px){
      div .rc-purchase-option__selector {
        font-size:1em;
      }
    }
  `;
  widgetRoot.appendChild(style);

  // When user clicks bundle radio (outside Recharge)
  document.querySelectorAll(".bundle-radio").forEach((el) => {
    el.addEventListener("click", () => {
      oneTimeInput.click();
      oneTimeRoot.classList.add("custom-active");
      const bundle_wrap = document.querySelector(".custom-radio");
      bundle_wrap.classList.add("active");
      console.log("One-time option activated.");
      // 3️⃣ Change Shopify quantity input → 3
      const qtyInput = document.querySelector(".quantity__input");
      if (qtyInput) {
        qtyInput.value = 3;
        qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
        console.log("Quantity changed to 3");
      }
    });
  });


  oneTimeInput.addEventListener("click", () => {
    if (oneTimeInput.checked) {
      oneTimeRoot.classList.remove("custom-active");
      const bundle_wrap = document.querySelector(".custom-radio");
      bundle_wrap.classList.remove("active");
      console.log("custom-active removed on selection");
      // 3️⃣ Change Shopify quantity input → 3
      const qtyInput = document.querySelector(".quantity__input");
      if (qtyInput) {
        qtyInput.value = 1;
        qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
        console.log("Quantity changed to 1");
      }
    }
  });
  subcriptionRootInput.addEventListener("click", () => {
    if (subcriptionRootInput.checked) {
      oneTimeRoot.classList.remove("custom-active");
      const bundle_wrap = document.querySelector(".custom-radio");
      bundle_wrap.classList.remove("active");
      console.log("custom-active removed on selection");
      // 3️⃣ Change Shopify quantity input → 3
      const qtyInput = document.querySelector(".quantity__input");
      if (qtyInput) {
        qtyInput.value = 1;
        qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
        console.log("Quantity changed to 1");
      }
    }
  });

  console.log("Recharge customization applied");
}, 200);
